import React, {useState, useEffect} from 'react';

import {commonUtils} from '@ibibo/hotel-utils';

import * as S from './PersonalProfile.styles';

const PersonalProfile = ({
  toggleBusinessProfile,
  noOfNameDetails,
  addGuestField,
  showAddGuest,
  updateDetailsExceptName,
  updateNameDetails,
  updatePanCheck,
  errors,
  isPan,
  panMessages,
  countryCodes,
  checkinTimeList,
  userInfo,
}) => {

  // Since we are not reading the input element and updating
  // we are updating the state with the user email and phone obtained from the redux directly.
  // Which will be sent on payment call
  useEffect(() => {
    updateDetailsExceptName('email', userInfo.email)
    updateDetailsExceptName('phoneNumber', userInfo.mobile)
  }, [userInfo.email,userInfo.mobile])

  return (
    <S.PersonalProfileWrapDiv>
      {Array(noOfNameDetails)
        .fill(1)
        .map((_, index) => (
          <S.ProfileDetailsEntryWrapDiv>
            <S.NameDetailsEntryWrapDiv>
              <S.TitleTxtWrapSpan>Title</S.TitleTxtWrapSpan>
              <S.NameEnterSelect onBlur={e => updateNameDetails('nameTitle', e.target.value, index)}>
                {commonUtils.titlesMap.map(({name, value}) => (
                  <option key={value} value={value}>{name}</option>
                ))}
              </S.NameEnterSelect>
            </S.NameDetailsEntryWrapDiv>
            <S.NameDetailsEntryWrapDiv>
              <S.TitleTxtWrapSpan>First Name</S.TitleTxtWrapSpan>
              <S.NameEnterInput
                type="text"
                onBlur={e => updateNameDetails('firstName', e.target.value, index)}
                placeholder="Enter First Name"
                errorBorder={(errors.firstName?.message && index == 0 && true) || false}
              />
              {index == 0 && <S.ErrorMessageDiv>{errors.firstName?.message}</S.ErrorMessageDiv>}
            </S.NameDetailsEntryWrapDiv>
            <S.NameDetailsEntryWrapDiv>
              <S.TitleTxtWrapSpan>Last Name</S.TitleTxtWrapSpan>
              <S.NameEnterInput
                type="text"
                placeholder="Enter Last Name"
                onBlur={e => updateNameDetails('lastName', e.target.value, index)}
                errorBorder={(errors.lastName?.message && index == 0 && true) || false}
              />
              {index == 0 && <S.ErrorMessageDiv>{errors.lastName?.message}</S.ErrorMessageDiv>}
            </S.NameDetailsEntryWrapDiv>
            <S.AddGuestWrapDiv disabled={!showAddGuest}>
              <S.AddGuestLink disabled={!showAddGuest} onClick={addGuestField}>+Add Guest</S.AddGuestLink>
            </S.AddGuestWrapDiv>
          </S.ProfileDetailsEntryWrapDiv>


        ))}

      <S.ProfileDetailsEntryWrapDiv>
        <S.NameDetailsEntryWrapDiv>
          <S.MobileEntryWrapDiv>
            <S.TitleTxtWrapSpan>Email Address</S.TitleTxtWrapSpan>
            {/* <S.MessageSentWrapSpan>
              (Your booking voucher will be sent to your login email address and phone number)
            </S.MessageSentWrapSpan> */}
          </S.MobileEntryWrapDiv>

          <S.MobileEnterInput readOnly = {true}
            type="text"
            value = {userInfo.email}
            errorBorder={(errors.email?.message && true) || false}
          />
        </S.NameDetailsEntryWrapDiv>
        <S.ErrorMessageDiv>{errors.email?.message}</S.ErrorMessageDiv>
      </S.ProfileDetailsEntryWrapDiv>

      <S.ProfileDetailsEntryWrapDiv>
        <S.NameDetailsEntryWrapDiv>
          <S.TitleTxtWrapSpan>Mobile Number</S.TitleTxtWrapSpan>
          <S.MobileInputOuterWrap>
            <S.CountryCodeWrap onChange={e => updateDetailsExceptName('countryCode', e.target.value)}>
              {countryCodes.map(({name, code}) => (
                <S.CountryCodeText value={code}>
                  +{code} {name}
                </S.CountryCodeText>
              ))}
            </S.CountryCodeWrap>
            <S.MobileNoWrapper
              readOnly = {true}
              value = {userInfo.mobile}
              type="text"
              errorBorder={(errors.phoneNumber?.message && true) || false}
              maxLength={10}
            />
          </S.MobileInputOuterWrap>
        </S.NameDetailsEntryWrapDiv>
        <S.ErrorMessageDiv>{errors.phoneNumber?.message}</S.ErrorMessageDiv>
      </S.ProfileDetailsEntryWrapDiv>

      {isPan && (
        <S.ProfileDetailsEntryWrapDiv>

          <S.NameDetailsEntryWrapDiv>
            <S.MobileEntryWrapDiv>
              <S.TitleTxtWrapSpan>PAN Number</S.TitleTxtWrapSpan>
            </S.MobileEntryWrapDiv>
            <S.MobileEnterInput
              type="text"
              placeholder="Enter PAN"
              onBlur={e => updateDetailsExceptName('travellersPan', e.target.value)}
              errorBorder={(errors.travellersPan?.message && true) || false}
              maxLength={10}
            />
            <S.ErrorMessageDiv>{errors.travellersPan?.message}</S.ErrorMessageDiv>
          </S.NameDetailsEntryWrapDiv>

          <S.NameDetailsEntryWrapDiv>
            <S.MobileEntryWrapDiv>
              <S.TitleTxtWrapSpan>PAN Name</S.TitleTxtWrapSpan>
            </S.MobileEntryWrapDiv>

            <S.MobileEnterInput
              type="text"
              placeholder="Enter Name"
              onBlur={e => updateDetailsExceptName('travellersPanName', e.target.value)}
              errorBorder={(errors.travellersPanName?.message && true) || false}
            />
            <S.ErrorMessageDiv>{errors.travellersPanName?.message}</S.ErrorMessageDiv>
          </S.NameDetailsEntryWrapDiv>

          <S.MessageDiv>Note:</S.MessageDiv>
          {panMessages.map((item, i) => <S.MessageListDiv key={`note${i}`}>{item}</S.MessageListDiv>)}

          <S.PanOuterEntryWrapDiv>
            <S.GstEntryWrapDiv>
              <S.PanDetailInput type="checkbox" onClick={e =>
                updatePanCheck('travellersPanTime', new Date().getTime())
              } />
              <S.MobileEntryWrapDiv>
                <S.MessageDiv>I confirm that the PAN Card provided here belongs to the payer (customer)</S.MessageDiv>
              </S.MobileEntryWrapDiv>
            </S.GstEntryWrapDiv>
            <S.ErrorMessageDiv>{errors.travellersPanTime?.message}</S.ErrorMessageDiv>
          </S.PanOuterEntryWrapDiv>

        </S.ProfileDetailsEntryWrapDiv>
      )}

      {!!checkinTimeList.length && (
        <S.ProfileDetailsEntryWrapDiv>
          <S.CheckinTimeWrapDiv>
            <S.TitleTxtWrapSpan>Expected Check-in Time</S.TitleTxtWrapSpan>
            <S.MobileInputOuterWrap>
              <S.ExpectedCheckinDropdown
                onChange={e => updateDetailsExceptName('selectedCheckinTime', e.target.value)}
              >
                {checkinTimeList.map(item => (
                  <S.CountryCodeText value={item}>{item}</S.CountryCodeText>
                ))}
              </S.ExpectedCheckinDropdown>
            </S.MobileInputOuterWrap>
          </S.CheckinTimeWrapDiv>
        </S.ProfileDetailsEntryWrapDiv>
      )}

      <S.GstOuterEntryWrapDiv>
        <S.GstEntryWrapDiv>
          <S.GstDetailInput type="checkbox" onClick={toggleBusinessProfile} />
          <S.MobileEntryWrapDiv>
            <S.TitleTxtWrapSpan>Enter Guest GST details</S.TitleTxtWrapSpan>
            {/* <S.MessageSentWrapSpan>(Optional for Business Profile)</S.MessageSentWrapSpan> */}
          </S.MobileEntryWrapDiv>
        </S.GstEntryWrapDiv>
      </S.GstOuterEntryWrapDiv>
    </S.PersonalProfileWrapDiv>
  );
};

export default PersonalProfile;
